{
  "name": "Shipyard",
  "skyDome": true,
  "skyDomeCol0": "#74a4b9",
  "skyDomeCol1": "#dce8ed",
  "skyDomeCol2": "#dce8ed",
  "ambient": 9800065,
  "light": 15390924,
  "sky": 14478324,
  "fog": 13481382,
  "fogD": 666.357503003984,
  "camPos": [-77, 46, 45],
  "spawns": [[15, 1, 62, 0, 2, 0], [-185, 1, 52, 0, 0, 0], [-79, 1, 201, 0, 2, 0], [61, 1, 207, 0, 2, 0], [-80, 27, 115, 0, 0, 0], [-179, 0, 143, 0, 3, 0], [-54, 1, -54, 0, 2, 0], [-42, 1, 129, 0, 3, 0], [15, 1, 62, 0, 2, 0], [-185, 1, 52, 0, 0, 0], [-79, 1, 201, 0, 2, 0], [61, 1, 207, 0, 2, 0], [-80, 27, 115, 0, 0, 0], [101, 1, -48, 0, 1, 0], [-179, 0, 143, 0, 3, 0], [-54, 1, -54, 0, 2, 0], [-42, 1, 129, 0, 3, 0]],
  "objects": [{
    "p": [-41, -10, 86],
    "s": [338, 10, 308],
    "c": "#f0f0f0",
    "t": 1
  }, {
    "p": [0, -1, 36],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [0, -1, 62],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "h": 500
  }, {
    "p": [0, 25, 62],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [0, 24, 36],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [26, 1, 70],
    "s": [5, 23, 1],
    "l": 1,
    "pe": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [0, 0, 74],
    "s": [58, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-83, -1, 36],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-83, -1, 62],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [0, -1, 114],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [0, -1, 140],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-83, -1, 115],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-83, 24, 141],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-55, -1, -53],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "h": 500
  }, {
    "p": [-55, 0, -41],
    "s": [57, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-55, 24, -53],
    "s": [57, 1, 23],
    "pe": 1,
    "v": 1
  }, {
    "p": [32, 0, 121],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-60, 0, 237],
    "s": [57, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-60, 24, 225],
    "s": [57, 1, 23],
    "pe": 1,
    "v": 1
  }, {
    "p": [-55, 0, -65],
    "s": [57, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-42, -1, 199],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-41, 0, 239],
    "s": [334, 20, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-209, 0, 190],
    "s": [2, 20, 100],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-179, -1, 73],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-196, 0, 185],
    "s": [24, 8, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-189, 0, 230],
    "s": [38, 3, 16],
    "c": "#969696",
    "e": "#373737",
    "t": 6
  }, {
    "p": [-169, 0, 233],
    "s": [2, 8, 10],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-169, 0, 224],
    "s": [2, 5, 8],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-158, 0, 232],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-252, 0, 160],
    "s": [14, 54, 18],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 0, 187],
    "s": [3, 26, 36],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-247, 0, 210],
    "s": [4, 54, 10],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 26, 187],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 33, 187],
    "s": [2, 14, 36],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-247, 47, 187],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-247, 33, 191],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 183],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 175],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 199],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 6, 233],
    "s": [3, 20, 36],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-247, 26, 233],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 33, 279],
    "s": [2, 14, 36],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-247, 33, 221],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 237],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 229],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 245],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 0, 256],
    "s": [4, 54, 10],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 26, 279],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-247, 0, 279],
    "s": [3, 26, 36],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-247, 33, 267],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 275],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 283],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 291],
    "s": [3, 14, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-247, 33, 233],
    "s": [2, 14, 36],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-247, 47, 233],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-247, 47, 279],
    "s": [4, 7, 36],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-209, 0, 49],
    "s": [2, 20, 74],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-209, 5, 11],
    "s": [2, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-304, -10, 86],
    "s": [188, 10, 308],
    "c": "#757370",
    "e": "#373737",
    "t": 6
  }, {
    "p": [-73, -10, 313],
    "s": [650, 10, 146],
    "c": "#969696",
    "e": "#373737",
    "t": 6
  }, {
    "p": [-209, 5, -15],
    "s": [2, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-209, 5, -41],
    "s": [2, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-209, 5, -28],
    "s": [1, 18, 77],
    "l": 1,
    "pe": 1,
    "t": 12
  }, {
    "p": [-209, 5, -67],
    "s": [2, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-209, 0, -28],
    "s": [2, 5, 80],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [0, 0, 50],
    "s": [58, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-164, 0, 138],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-201, 0, 54],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-163, 0, 138],
    "s": [16, 8, 48],
    "v": 1
  }, {
    "p": [-163, 8, 143],
    "s": [16, 7, 24],
    "pe": 1,
    "v": 1
  }, {
    "p": [-11, 0, 202],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-5, 0, 202],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [1, 0, 202],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [7, 0, 202],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-2, 2, 210],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-2, 2, 206],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-2, 2, 202],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-2, 2, 198],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-2, 2, 194],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [100, 0, 177],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 0, 177],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [116, 0, 177],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 2, 185],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 2, 181],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 2, 177],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 2, 173],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [108, 2, 169],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-201, 0, -43],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-195, 0, -43],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-189, 0, -43],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-183, 0, -43],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-192, 2, -35],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-192, 2, -39],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-192, 2, -43],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-192, 2, -47],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-192, 2, -51],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-279, 0, 47],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-273, 0, 47],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-267, 0, 47],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-261, 0, 47],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-270, 2, 55],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-270, 2, 51],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-270, 2, 47],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-270, 2, 43],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-270, 2, 39],
    "s": [20, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [80, 0, -24],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 0, -24],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [96, 0, -24],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 2, -16],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 2, -20],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 2, -24],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 2, -28],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [88, 2, -32],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [87, 3, -16],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [88, 3, -24],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [92, 5, -24],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [88, 5, -24],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [84, 5, -24],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [80, 5, -25],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 1.48, 0],
    "t": 2
  }, {
    "p": [80, 6, -23],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [88, 6, -24],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [96, 6, -25],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [89, 8, -16],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [88, 8, -20],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [88, 8, -24],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [88, 8, -28],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [87, 8, -32],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [88, 0, -25],
    "s": [18, 9, 18],
    "l": 1,
    "v": 1
  }, {
    "p": [127, 0, 131],
    "s": [2, 20, 214],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-209, 0, 113],
    "s": [2, 5, 54],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-209, 5, 139],
    "s": [2, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-209, 5, 113],
    "s": [1, 18, 51],
    "pe": 1,
    "t": 12
  }, {
    "p": [-209, 5, 113],
    "s": [2, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [127, 0, -2],
    "s": [2, 5, 52],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [127, 5, 24],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [127, 5, -28],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [127, 5, -2],
    "s": [1, 18, 51],
    "l": 1,
    "pe": 1,
    "t": 12
  }, {
    "p": [127, 5, -2],
    "s": [1, 19, 1],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [53, 0, -31],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [88, 0, -40],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [76, 0, 69],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [58, 0, 191],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [58, 0, 191],
    "s": [47, 8, 16],
    "v": 1
  }, {
    "p": [63, 8, 191],
    "s": [25, 7, 16],
    "pe": 1,
    "v": 1
  }, {
    "p": [-59, -10, -90],
    "s": [769, 10, 44],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [-41, -18, -573],
    "s": [2011, 10, 1958],
    "l": 1,
    "c": "#2a4957",
    "o": 0.9,
    "t": 5,
    "ab": 1
  }, {
    "p": [-277, 0, 152],
    "s": [36, 26, 1],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-300, 0, 160],
    "s": [10, 54, 18],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-323, 8, 152],
    "s": [36, 23, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-277, 26, 153],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-277, 33, 154],
    "s": [36, 14, 4],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-265, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-273, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-281, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-289, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-323, 26, 153],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-323, 33, 154],
    "s": [36, 14, 4],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-335, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-327, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-319, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-311, 33, 153],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-346, 0, 153],
    "s": [10, 54, 4],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-277, 47, 153],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-323, 47, 153],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-349, 0, 233],
    "s": [4, 54, 156],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-277, 0, 314],
    "s": [36, 26, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-252, 0, 306],
    "s": [14, 54, 18],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-300, 0, 306],
    "s": [10, 54, 18],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-346, 0, 313],
    "s": [10, 54, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-323, 0, 314],
    "s": [36, 26, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-277, 26, 313],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-323, 26, 313],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-323, 47, 313],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-277, 47, 313],
    "s": [36, 7, 4],
    "l": 1,
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-277, 33, 312],
    "s": [36, 14, 4],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-265, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-273, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-281, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-289, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-323, 33, 312],
    "s": [36, 14, 4],
    "l": 1,
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-311, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-319, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-327, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-335, 33, 313],
    "s": [1, 14, 3],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-298, 54, 233],
    "s": [112, 2, 170],
    "l": 1,
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-349, 0, 43],
    "s": [2, 54, 218],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [-14, 0, -111],
    "s": [206, 5, 2],
    "l": 1,
    "c": "#706857",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-171, 0, -79],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [125, 16, 204],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [124, 9, 204],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [123, 0, 204],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [125, 9, 210],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, 206],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, 202],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, 198],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 0, 204],
    "s": [3, 18, 14],
    "l": 1,
    "v": 1
  }, {
    "p": [-14, 5, -111],
    "s": [206, 2, 3],
    "l": 1,
    "c": "#aca596",
    "e": "#313131"
  }, {
    "p": [-131, -116, -192],
    "s": [28, 116, 160],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [-323, -84, -192],
    "s": [28, 84, 160],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [103, -176, -192],
    "s": [28, 176, 160],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [188, 0, -84],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [123, 0, -100],
    "s": [12, 12, 12],
    "i": 8,
    "l": 1
  }, {
    "p": [-15, 0, -80],
    "s": [12, 12, 12],
    "i": 8,
    "l": 1
  }, {
    "p": [-60, 0, -103],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-67, 12, -102],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-73, 0, -100],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1
  }, {
    "p": [-125, 0, -101],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 0, -101],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-109, 0, -101],
    "s": [2, 2, 18],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 2, -93],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 2, -97],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 2, -101],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 2, -105],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [-117, 2, -109],
    "s": [18, 1, 2],
    "l": 1,
    "t": 2
  }, {
    "p": [39, 0, -98],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1
  }, {
    "p": [-233, 0, -106],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1
  }, {
    "p": [220, 0, -111],
    "s": [206, 5, 2],
    "l": 1,
    "c": "#706857",
    "e": "#313131",
    "t": 11
  }, {
    "p": [220, 5, -111],
    "s": [206, 2, 3],
    "l": 1,
    "c": "#aca596",
    "e": "#313131"
  }, {
    "p": [-227, 0, -111],
    "s": [164, 5, 2],
    "l": 1,
    "c": "#706857",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-227, 5, -111],
    "s": [164, 2, 3],
    "l": 1,
    "c": "#aca596",
    "e": "#313131"
  }, {
    "p": [-687, -10, -192],
    "s": [487, 10, 248],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [-41, 5, -67],
    "s": [334, 18, 1],
    "l": 1,
    "pe": 1,
    "t": 12
  }, {
    "p": [-183, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-157, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-131, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-87, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-61, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-35, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-9, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [17, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-41, 0, -67],
    "s": [334, 5, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [47, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [73, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [99, 5, -67],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [125, 5, -67],
    "s": [2, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-390, 0, -111],
    "s": [107, 5, 2],
    "l": 1,
    "c": "#706857",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-390, 5, -111],
    "s": [107, 2, 3],
    "l": 1,
    "c": "#aca596",
    "e": "#313131"
  }, {
    "p": [25, 0, 21],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [123, 0, 28],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [124, 0, 214],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-173, 3, 236],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-215, 0, -12],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-269, 3, 41],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-342, 0, 94],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-342, 0, 106],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-289, 0, 72],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-258, 0, 141],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-342, 0, 135],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-268, 0, 137],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-330, 1, 62],
    "s": [2, 1, 1],
    "l": 1,
    "r": [-0.01, -1.48, -0.02],
    "c": "#d2cdc3",
    "e": "#313131"
  }, {
    "p": [-280, 0, -67],
    "s": [140, 29, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [135, 0, 289],
    "s": [14, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 0, 262],
    "s": [3, 26, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [130, 0, 239],
    "s": [4, 54, 10],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 26, 262],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 33, 262],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [130, 47, 262],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [130, 33, 258],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 266],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 274],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 250],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 0, 216],
    "s": [4, 33, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 33, 170],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [130, 33, 228],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 212],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 220],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 204],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 0, 193],
    "s": [4, 54, 10],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 0, 170],
    "s": [4, 33, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [130, 33, 182],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 174],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 166],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 158],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 216],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [130, 47, 216],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [130, 47, 170],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [160, 0, 297],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [183, 0, 289],
    "s": [10, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 8, 297],
    "s": [36, 23, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [160, 26, 296],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [160, 33, 295],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [148, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [156, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [172, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 26, 296],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 33, 295],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [218, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [210, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [202, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [194, 33, 296],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [229, 0, 296],
    "s": [10, 54, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [160, 47, 296],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [206, 47, 296],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [232, 0, 216],
    "s": [4, 54, 156],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [160, 0, 135],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [135, 0, 143],
    "s": [14, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [183, 0, 143],
    "s": [10, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [229, 0, 136],
    "s": [10, 54, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 0, 135],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [160, 26, 136],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 26, 136],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 47, 136],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [160, 47, 136],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [160, 33, 137],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [148, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [156, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [172, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 137],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [194, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [202, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [210, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [218, 33, 136],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [181, 54, 216],
    "s": [112, 2, 170],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-145, 0, 277],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-118, 0, 272],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-95, 0, 272],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-118, 26, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-118, 33, 272],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-118, 47, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-114, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-122, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-130, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-106, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-72, 0, 272],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-72, 26, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-26, 33, 272],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-84, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-68, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-76, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-60, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-49, 0, 272],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-26, 26, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-26, 0, 272],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-38, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-30, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-22, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-14, 33, 272],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-72, 33, 272],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-72, 47, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-26, 47, 272],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-153, 0, 302],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-145, 0, 325],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-153, 8, 348],
    "s": [36, 23, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-152, 26, 302],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-151, 33, 302],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-152, 33, 290],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 298],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 306],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 314],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 26, 348],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-151, 33, 348],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-152, 33, 360],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 352],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 344],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 33, 336],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-152, 0, 371],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-152, 47, 302],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-152, 47, 348],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-72, 0, 374],
    "s": [4, 54, 156],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [9, 0, 302],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [1, 0, 277],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [1, 0, 325],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [8, 0, 371],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [9, 0, 348],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [8, 26, 302],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [8, 26, 348],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [8, 47, 348],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [8, 47, 302],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [7, 33, 302],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [8, 33, 290],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 298],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 306],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 314],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [7, 33, 348],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [8, 33, 336],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 344],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 352],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [8, 33, 360],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-72, 54, 323],
    "s": [112, 2, 170],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [169, 0, 87],
    "s": [14, 54, 18],
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 0, 60],
    "s": [3, 26, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [164, 0, 37],
    "s": [4, 54, 10],
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 26, 60],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 33, 60],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [164, 47, 60],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [164, 33, 56],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 64],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 72],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 48],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 0, 14],
    "s": [3, 26, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [164, 26, 14],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 33, -32],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [164, 33, 26],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 10],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 18],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 2],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 0, -9],
    "s": [4, 54, 10],
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 26, -32],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [164, 0, -32],
    "s": [3, 26, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [164, 33, -20],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, -28],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, -36],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, -44],
    "s": [3, 14, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [164, 33, 14],
    "s": [2, 14, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [164, 47, 14],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [164, 47, -32],
    "s": [4, 7, 36],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [194, 0, 95],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [217, 0, 87],
    "s": [10, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [240, 8, 95],
    "s": [36, 23, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [194, 26, 94],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [194, 33, 93],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [182, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [190, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [198, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [240, 26, 94],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [240, 33, 93],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [252, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [244, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [236, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [228, 33, 94],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [263, 0, 94],
    "s": [10, 54, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [194, 47, 94],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [240, 47, 94],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [266, 0, 14],
    "s": [4, 54, 156],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [194, 0, -67],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [169, 0, -59],
    "s": [14, 54, 18],
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [217, 0, -59],
    "s": [10, 54, 18],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [263, 0, -66],
    "s": [10, 54, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [240, 0, -67],
    "s": [36, 26, 1],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [194, 26, -66],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [240, 26, -66],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [240, 47, -66],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [194, 47, -66],
    "s": [36, 7, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [194, 33, -65],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [182, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [190, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [198, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [240, 33, -65],
    "s": [36, 14, 4],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [228, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [236, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [244, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [252, 33, -66],
    "s": [1, 14, 3],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [215, 54, 14],
    "s": [112, 2, 170],
    "l": 1,
    "r": [-3.14, 0, -3.14],
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [305, -10, 168],
    "s": [42, 10, 472],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [324, 0, -31],
    "s": [2, 5, 162],
    "l": 1,
    "c": "#706857",
    "e": "#313131",
    "t": 11
  }, {
    "p": [324, 5, -33],
    "s": [2, 2, 159],
    "l": 1,
    "c": "#aca596",
    "e": "#313131"
  }, {
    "p": [266, 0, 115],
    "s": [2, 29, 44],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [249, 0, 136],
    "s": [32, 29, 2],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [145, 0, -67],
    "s": [34, 20, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [171, 0, 127],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [135, 0, 47],
    "s": [12, 12, 12],
    "i": 8,
    "l": 1
  }, {
    "p": [99, 0, 129],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [87, 0, 129],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [92, 12, 129],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-672, -10, 159],
    "s": [548, 10, 454],
    "l": 1,
    "c": "#f0f0f0",
    "t": 8
  }, {
    "p": [-346, -10, 582],
    "s": [1200, 10, 392],
    "l": 1,
    "c": "#f0f0f0",
    "t": 8
  }, {
    "p": [-289, 0, 15],
    "s": [16, 24, 102],
    "c": "#c1c2c3",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-281, 0, -14],
    "s": [3, 20, 10],
    "i": 21,
    "l": 1
  }, {
    "p": [-296, 27, -24],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-289, 23, 15],
    "s": [18, 2, 103],
    "l": 1,
    "r": [0, 0, -0.09],
    "c": "#55504d",
    "e": "#212b31",
    "t": 10
  }, {
    "p": [-314, 0, 15],
    "s": [34, 46, 102],
    "l": 1,
    "c": "#c1c2c3",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-340, 0, 15],
    "s": [18, 33, 102],
    "l": 1,
    "c": "#c1c2c3",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-296, 27, 54],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-296, 27, 2],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-296, 27, 28],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1
  }, {
    "p": [-314, 0, 66],
    "s": [27, 23, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-305, 45, 15],
    "s": [18, 3, 103],
    "l": 1,
    "r": [0, 0, -0.09],
    "c": "#55504d",
    "e": "#212b31",
    "t": 10
  }, {
    "p": [-323, 48, 15],
    "s": [18, 3, 103],
    "l": 1,
    "r": [0, 0, -3.06],
    "c": "#55504d",
    "e": "#212b31",
    "t": 10
  }, {
    "p": [-340, 34, 15],
    "s": [18, 3, 103],
    "l": 1,
    "r": [0, 0, -3.06],
    "c": "#55504d",
    "e": "#212b31",
    "t": 10
  }, {
    "p": [-314, 26, 67],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, -1.57, 0]
  }, {
    "p": [-314, 26, -38],
    "s": [1, 17, 17],
    "i": 22,
    "l": 1,
    "r": [0, 1.57, 0]
  }, {
    "p": [-314, 0, -36],
    "s": [27, 23, 1],
    "l": 1,
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-342, 0, -51],
    "s": [10, 9, 18],
    "l": 1,
    "c": "#ffedde",
    "t": 10
  }, {
    "p": [-342, 9, -51],
    "s": [11, 1, 20],
    "l": 1,
    "r": [0, 0, -0.09],
    "c": "#312d2a",
    "t": 10
  }, {
    "p": [-337, 3, -51],
    "s": [1, 1, 17],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-337, 6, -51],
    "s": [1, 1, 17],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-342, 6, -60],
    "s": [11, 1, 1],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-342, 3, -60],
    "s": [11, 1, 1],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-342, 3, -42],
    "s": [11, 1, 1],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-342, 6, -42],
    "s": [11, 1, 1],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-347, 3, -51],
    "s": [1, 1, 17],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-347, 6, -51],
    "s": [1, 1, 17],
    "l": 1,
    "c": "#ffedde",
    "t": 10,
    "ab": 1
  }, {
    "p": [-229, 0, 315],
    "s": [42, 29, 2],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-209, 0, 277],
    "s": [2, 29, 74],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [-255, 0, -21],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-247, 0, -22],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-239, 0, -23],
    "s": [2, 2, 18],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-246, 2, -14],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-247, 2, -18],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-247, 2, -22],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-247, 2, -26],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-248, 2, -30],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0.09, 0],
    "t": 2
  }, {
    "p": [-264, 0, -60],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-218, 0, -3],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-238, 0, 306],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-222, 0, -59],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-192, 0, 58],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-142, 0, -64],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-278, 0, -1],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-131, 1, -259],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-131, 0, -259],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-131, 5, -259],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-131, 0, -259],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-321, 1, -259],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-321, 0, -259],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-321, 5, -259],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-321, 0, -259],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-460, 1, -301],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-460, 0, -301],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-460, 5, -301],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-460, 0, -301],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [103, 1, -259],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [103, 0, -259],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [103, 5, -259],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [103, 0, -259],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [241, 0, 398],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "c": "#52452e"
  }, {
    "p": [7, -15, 397],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#52452e"
  }, {
    "p": [-342, -10, 480],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#52452e"
  }, {
    "p": [-376, -2, 395],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -1.13, 0],
    "c": "#52452e"
  }, {
    "p": [-465, -2, 286],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-453, -23, 157],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-584, -2, 338],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#52452e"
  }, {
    "p": [123, -15, 463],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#52452e"
  }, {
    "p": [-516, 0, -262],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-516, 0, -203],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-516, 0, -174],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-517, 25, -188],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-619, 0, -137],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-614, 0, -225],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-471, 0, -270],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, -0.18, 0]
  }, {
    "p": [-478, 0, -231],
    "s": [12, 12, 12],
    "i": 1,
    "l": 1,
    "r": [0, 0.26, 0]
  }, {
    "p": [-474, 0, -172],
    "s": [12, 12, 12],
    "i": 8,
    "l": 1
  }, {
    "p": [-253, 57, 168],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 168],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 61, 168],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 168],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 57, 183],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 183],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 61, 183],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 183],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 57, 290],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 290],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 61, 290],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-253, 56, 290],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-309, 49, 44],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-309, 48, 44],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-309, 53, 44],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-309, 48, 44],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-147, 57, 289],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-147, 56, 289],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-147, 61, 289],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-147, 56, 289],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-135, 57, 289],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-135, 56, 289],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-135, 61, 289],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-135, 56, 289],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-5, 57, 289],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-5, 56, 289],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-5, 61, 289],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [-5, 56, 289],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 57, 282],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 282],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 61, 282],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 282],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 57, 159],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 159],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 61, 159],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 159],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 57, 146],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 146],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 61, 146],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [146, 56, 146],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 57, 84],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, 84],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 61, 84],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, 84],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 57, 71],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, 71],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 61, 71],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, 71],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 57, -57],
    "s": [4, 4, 4],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, -57],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 61, -57],
    "s": [6, 3, 6],
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [172, 56, -57],
    "s": [8, 8, 8],
    "l": 1,
    "v": 1,
    "c": "#483d3d",
    "t": 6
  }, {
    "p": [30, 0, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffc765"
  }, {
    "p": [-24, 0, -43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.7, -3.14],
    "c": "#ffffff"
  }, {
    "p": [45, 0, -26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-14, 0, -13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [20, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [58, 0, -24],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [81, -1, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#ffffff"
  }, {
    "p": [123, 0, 25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [77, 0, -15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [32, 0, 22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [28, 0, 100],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [87, 0, 94],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [30, 0, 128],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [80, 0, 121],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [123, 0, 112],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.96, -3.14],
    "c": "#ffffff"
  }, {
    "p": [78, 0, 134],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [105, 0, 135],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [100, 0, 187],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [109, 0, 177],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [102, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [58, 0, 204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [82, 0, 201],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [39, 0, 180],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [4, 0, 193],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#ffffff"
  }, {
    "p": [-8, 0, 210],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [-29, 0, 154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [29, 0, 154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-53, 0, 155],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-39, 0, 184],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-12, 0, 185],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-19, 0, 215],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-19, 0, 234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [33, 0, 234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [123, 0, 235],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [-53, 0, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-50, 0, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-29, 0, 101],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-31, 0, 141],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#ffffff"
  }, {
    "p": [-30, 0, 48],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-29, 0, 22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.22, 0],
    "c": "#ffffff"
  }, {
    "p": [-21, 0, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#ffffff"
  }, {
    "p": [-75, 0, -13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-112, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [-90, 0, 211],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-73, 0, 209],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-151, 0, 226],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-154, 0, 163],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-173, 0, 163],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-164, 0, 222],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#ffffff"
  }, {
    "p": [-205, 0, 140],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#ffffff"
  }, {
    "p": [-202, 0, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-191, 0, 181],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-203, 0, 89],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [-170, 0, 113],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#ffffff"
  }, {
    "p": [-114, 0, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-154, 0, 140],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-150, 0, 59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-112, 0, 76],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-95, 0, 99],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#ffffff"
  }, {
    "p": [-54, 0, 102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-12, 0, 78],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-76, 0, -27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-89, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#ffffff"
  }, {
    "p": [-116, 0, -65],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-81, 0, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-93, 0, 20],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.13, -3.14],
    "c": "#ffffff"
  }, {
    "p": [-112, 0, 23],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-142, 0, -17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-181, 0, -33],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-145, 0, -62],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-204, 0, -7],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [-203, 0, -59],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#ffffff"
  }, {
    "p": [-187, 0, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#ffffff"
  }, {
    "p": [-196, 0, -39],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.44, 0],
    "c": "#ffffff"
  }, {
    "p": [-204, 0, 45],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#ffffff"
  }, {
    "p": [-114, 0, 50],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-186, 0, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-192, 0, 50],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-205, 0, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#ffffff"
  }, {
    "p": [73, 0, 207],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-300, 0, 392],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-273, 0, 387],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-250, 0, 387],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-273, 26, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-273, 33, 387],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-273, 47, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-269, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-277, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-285, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-261, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-227, 0, 387],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-227, 26, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-181, 33, 387],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-239, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-223, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-231, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-215, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-204, 0, 387],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-181, 26, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-181, 0, 387],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-193, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-185, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-177, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-169, 33, 387],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-227, 33, 387],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-227, 47, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-181, 47, 387],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-308, 0, 417],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-300, 0, 440],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-308, 8, 463],
    "s": [36, 23, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-307, 26, 417],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-306, 33, 417],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-307, 33, 405],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 413],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 421],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 429],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 26, 463],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-306, 33, 463],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-307, 33, 475],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 467],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 459],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 33, 451],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-307, 0, 486],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-307, 47, 417],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-307, 47, 463],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-227, 0, 489],
    "s": [4, 54, 156],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-146, 0, 417],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-154, 0, 392],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-154, 0, 440],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-147, 0, 486],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-146, 0, 463],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [-147, 26, 417],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-147, 26, 463],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [-147, 47, 463],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-147, 47, 417],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [-148, 33, 417],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-147, 33, 405],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 413],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 421],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 429],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-148, 33, 463],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [-147, 33, 451],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 459],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 467],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-147, 33, 475],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-227, 54, 438],
    "s": [112, 2, 170],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [127, 20, 239],
    "s": [2, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-41, 20, 239],
    "s": [335, 18, 1],
    "l": 1,
    "pe": 1,
    "t": 12
  }, {
    "p": [101, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [75, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [49, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [23, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-3, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-29, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-55, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-81, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-107, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-133, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-159, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-185, 20, 239],
    "s": [1, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-209, 20, 239],
    "s": [2, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [53, 0, 329],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [80, 0, 324],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [103, 0, 324],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [80, 26, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [80, 33, 324],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [80, 47, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [84, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [76, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [68, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [92, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [126, 0, 324],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [126, 26, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [172, 33, 324],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [114, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [130, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [122, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [138, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [149, 0, 324],
    "s": [4, 54, 10],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [172, 26, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [172, 0, 324],
    "s": [3, 26, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [160, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [168, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [176, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [184, 33, 324],
    "s": [3, 14, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [126, 33, 324],
    "s": [2, 14, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [126, 47, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [172, 47, 324],
    "s": [4, 7, 36],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [45, 0, 354],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [53, 0, 377],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [45, 8, 400],
    "s": [36, 23, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [46, 26, 354],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [47, 33, 354],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [46, 33, 342],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 350],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 358],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 366],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 26, 400],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [47, 33, 400],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [46, 33, 412],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 404],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 396],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 33, 388],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [46, 0, 423],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [46, 47, 354],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [46, 47, 400],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [126, 0, 426],
    "s": [4, 54, 156],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [207, 0, 354],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [199, 0, 329],
    "s": [14, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [199, 0, 377],
    "s": [10, 54, 18],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 0, 423],
    "s": [10, 54, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [207, 0, 400],
    "s": [36, 26, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#1e1e1e",
    "t": 10
  }, {
    "p": [206, 26, 354],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 26, 400],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6
  }, {
    "p": [206, 47, 400],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [206, 47, 354],
    "s": [36, 7, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#ffffff",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [205, 33, 354],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [206, 33, 342],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 350],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 358],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 366],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [205, 33, 400],
    "s": [36, 14, 4],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#1e1a14",
    "e": "#1b1919",
    "o": 0.9,
    "t": 10
  }, {
    "p": [206, 33, 388],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 396],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 404],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [206, 33, 412],
    "s": [1, 14, 3],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [126, 54, 375],
    "s": [112, 2, 170],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#554242",
    "e": "#3e4448",
    "t": 6,
    "ab": 1
  }, {
    "p": [22, -15, 437],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#52452e"
  }, {
    "p": [14, 0, 415],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [-41, 0, 500],
    "s": [334, 29, 2],
    "l": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 11
  }, {
    "p": [268, -10, 319],
    "s": [32, 10, 158],
    "l": 1,
    "c": "#827c6c"
  }, {
    "p": [-542, 0, -96],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-623, 0, -286],
    "s": [57, 26, 25],
    "i": 17,
    "l": 1
  }, {
    "p": [-433, -23, 38],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-501, -23, -23],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-520, -23, 87],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-540, -23, 201],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-553, -23, 275],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-443, -23, 460],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [-110, -23, 517],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [7, -23, 537],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [127, -23, 531],
    "s": [65, 109, 54],
    "i": 15,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#52452e"
  }, {
    "p": [68, 0, -94],
    "s": [51, 15, 20],
    "i": 7,
    "l": 1
  }, {
    "p": [-209, 5, 87],
    "s": [2, 19, 2],
    "l": 1,
    "pe": 1,
    "c": "#a0998a",
    "e": "#313131",
    "t": 6
  }, {
    "p": [-142, 0, -22],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [32, 0, 27],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-185, 0, 187],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-83, -1, 141],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-151, 0, -8],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-151, 0, -20],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-158, 0, -2],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-44, -1, -27],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [-83, 25, 115],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "h": 500
  }, {
    "p": [3, 0, 154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#ffffff"
  }, {
    "p": [-2, 0, 202],
    "s": [20, 2, 18],
    "v": 1,
    "t": 2
  }, {
    "p": [108, 0, 177],
    "s": [18, 2, 18],
    "v": 1,
    "t": 2
  }, {
    "p": [-191, 0, -43],
    "s": [18, 2, 18],
    "v": 1,
    "t": 2
  }, {
    "p": [88, 0, -24],
    "s": [18, 9, 18],
    "pe": 1,
    "v": 1,
    "t": 2
  }, {
    "p": [79, 0, -36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [123, 0, -8],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [41, 0, -31],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [206, -10, 86],
    "s": [156, 10, 308],
    "c": "#969696",
    "e": "#373737",
    "t": 6
  }, {
    "p": [135, 0, -48],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [35, 0, 112],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [86, 0, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [65, 0, 43],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [77, 0, 69],
    "s": [16, 8, 48],
    "v": 1
  }, {
    "p": [77, 8, 74],
    "s": [16, 7, 24],
    "pe": 1,
    "v": 1
  }, {
    "p": [-60, -1, 225],
    "s": [57, 26, 25],
    "i": 19,
    "l": 1,
    "h": 500
  }, {
    "p": [26, 1, 62],
    "s": [4, 23, 23],
    "pe": 1,
    "c": "#662626",
    "t": 5
  }, {
    "p": [26, 1, 54],
    "s": [5, 23, 1],
    "l": 1,
    "pe": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [26, 1, 62],
    "s": [5, 23, 1],
    "l": 1,
    "pe": 1,
    "c": "#282828",
    "t": 5
  }, {
    "p": [32, 0, 48],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#ffffff"
  }, {
    "p": [32, 0, 53],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [32, 0, 71],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#ffffff"
  }, {
    "p": [-83, 25, 103],
    "s": [57, 25, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-83, 50, 115],
    "s": [57, 1, 25],
    "pe": 1,
    "v": 1
  }, {
    "p": [-60, -1, 213],
    "s": [57, 26, 1],
    "pe": 1,
    "v": 1
  }, {
    "p": [-83, 25, 115],
    "s": [57, 2, 25],
    "pe": 1,
    "v": 1
  }, {
    "p": [-115, 0, 31],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-148, 0, 65],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-115, 0, 119],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-185, 0, 179],
    "s": [3, 1, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-74, 0, 191],
    "s": [3, 1, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-31, 0, 148],
    "s": [3, 1, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [78, 0, 128],
    "s": [3, 2, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [76, 0, -32],
    "s": [3, 2, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [74, 0, -63],
    "s": [6, 2, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [14, 0, 20],
    "s": [6, 2, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [90, 0, 87],
    "s": [6, 2, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-31, 0, 41],
    "s": [3, 1, 6],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-49, 0, -12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.27, 0],
    "c": "#ffffff"
  }, {
    "p": [-179, 0, 187],
    "s": [5, 1, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-204, 0, 219],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#ffffff"
  }, {
    "p": [-118, 0, 235],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#ffffff"
  }, {
    "p": [-84, 0, 156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#ffffff"
  }, {
    "p": [-120, 0, 188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [-120, 0, 175],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [-158, 0, 222],
    "s": [5, 1, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-127, 0, 190],
    "s": [5, 1, 4],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [-127, 0, 181],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [123, 0, 108],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [50, 0, 180],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-180, 0, 182],
    "s": [4, 7, 4],
    "i": 16,
    "l": 1
  }, {
    "p": [-157, 0, -27],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [55, 0, -39],
    "s": [6, 1, 3],
    "l": 1,
    "c": "#646464",
    "t": 5
  }, {
    "p": [48, 0, -39],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#ffc765"
  }, {
    "p": [-178, 0, 212],
    "s": [59, 50, 51],
    "i": 14
  }, {
    "p": [-167, 0, -23],
    "s": [79, 50, 81],
    "i": 14
  }, {
    "p": [74, 0, 204],
    "s": [101, 50, 66],
    "i": 14
  }, {
    "p": [38, 0, 27],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [111, 0, 31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [81, 0, 36],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [98, 0, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#ffffff"
  }, {
    "p": [88, 0, -25],
    "s": [18, 9, 18],
    "l": 1,
    "v": 1
  }, {
    "p": [88, 0, -11],
    "s": [18, 2, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [88, 8, -13],
    "s": [18, 2, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [88, 16, -14],
    "s": [18, 2, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [96, 0, -12],
    "s": [2, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [125, 16, -57],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [124, 9, -57],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [123, 0, -57],
    "s": [2, 2, 14],
    "l": 1,
    "r": [0, 0, -0.09],
    "t": 2
  }, {
    "p": [125, 9, -51],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, -55],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, -59],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 9, -63],
    "s": [18, 1, 2],
    "l": 1,
    "r": [0, 0, -1.66],
    "t": 2
  }, {
    "p": [125, 0, -57],
    "s": [3, 18, 14],
    "l": 1,
    "v": 1
  }, {
    "p": [127, 0, -48],
    "s": [2, 20, 40],
    "c": "#a0998a",
    "e": "#313131",
    "t": 11,
    "bo": 1
  }, {
    "p": [121, -1, -49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#ffffff"
  }, {
    "p": [93, 0, -25],
    "s": [64, 50, 81],
    "i": 14
  }, {
    "p": [92, 0, -12],
    "s": [2, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [88, 0, -12],
    "s": [2, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [84, 0, -12],
    "s": [2, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [90, 0, -13],
    "s": [2, 18, 5],
    "pe": 1,
    "v": 1,
    "t": 2
  }, {
    "p": [80, 0, -12],
    "s": [2, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "t": 2
  }, {
    "p": [92, 0, -13],
    "s": [2, 18, 5],
    "v": 1,
    "t": 2
  }, {
    "p": [86, 0, -13],
    "s": [2, 18, 5],
    "pe": 1,
    "v": 1,
    "t": 2
  }, {
    "p": [82, 0, -13],
    "s": [2, 18, 5],
    "pe": 1,
    "v": 1,
    "t": 2
  }, {
    "p": [94, 0, -13],
    "s": [2, 18, 5],
    "pe": 1,
    "v": 1,
    "t": 2
  }, {
    "p": [96, 0, -13],
    "s": [2, 18, 5],
    "v": 1,
    "t": 2
  }, {
    "p": [88, 0, -13],
    "s": [2, 18, 5],
    "v": 1,
    "t": 2
  }, {
    "p": [84, 0, -13],
    "s": [2, 18, 5],
    "v": 1,
    "t": 2
  }, {
    "p": [80, 0, -13],
    "s": [2, 18, 5],
    "v": 1,
    "t": 2
  }, {
    "p": [0, 24, 36],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-44, -1, -27],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [0, 0, 36],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-83, -1, 36],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-83, -1, 62],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-83, 0, 115],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-83, 0, 141],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-42, -1, 199],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-83, 24, 141],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [0, -1, 140],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [0, -1, 114],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [0, 26, 62],
    "s": [54, 23, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [-179, -1, 73],
    "s": [54, 24, 23],
    "l": 1,
    "t": 5
  }, {
    "p": [88, 12, -40],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-74, 76, 276],
    "s": [74, 0, 30],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 3.14],
    "sad": 1
  }, {
    "p": [-346, 33, 107],
    "s": [67, 0, 28],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [-74, 59, 277],
    "s": [1, 34, 79],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#b4b2b0",
    "t": 6,
    "ab": 1
  }, {
    "p": [-43, 56, 280],
    "s": [4, 40, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#b4b2b0",
    "t": 6,
    "ab": 1
  }, {
    "p": [-108, 56, 279],
    "s": [3, 39, 5],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#b4b2b0",
    "t": 6,
    "ab": 1
  }, {
    "p": [-347, 17, 107],
    "s": [71, 32, 1],
    "l": 1,
    "r": [0, 1.57, 0],
    "c": "#b4b2b0",
    "t": 6,
    "ab": 1
  }]
}